import { EVENT_KEY_MAP, LOCAL_STORAGE_KEYS } from 'utils/constants'
import { getCurrentUTCDateTime, getUTCOffset } from './time'

export const getCaregiverSelectedParticipantId = () => {
  try {
    const raw = localStorage.getItem('selected_ptp')
    if (!raw) return undefined
    const parsed = JSON.parse(raw)
    return parsed?.id !== undefined && parsed?.id !== null
      ? String(parsed.id)
      : undefined
  } catch (_) {
    return undefined
  }
}

const getUserFromLocalStorage = () => {
  try {
    const raw = localStorage.getItem(LOCAL_STORAGE_KEYS.user)
    if (!raw) return {}
    return JSON.parse(raw) || {}
  } catch (_) {
    return {}
  }
}

const getEventContext = () => {
  const user = getUserFromLocalStorage()
  const participant_or_caregiver_id =
    user?.id !== undefined && user?.id !== null ? String(user.id) : undefined
  const caregiver_selected_ptp_id =
    user?.is_caregiver ? getCaregiverSelectedParticipantId() : undefined
  return { participant_or_caregiver_id, caregiver_selected_ptp_id }
}

const applyContextToInfo = (info, ctx) => {
  const nextInfo = { ...info }
  if (ctx.caregiver_selected_ptp_id) {
    nextInfo.caregiver_selected_ptp_id = ctx.caregiver_selected_ptp_id
  }
  return nextInfo
}

const makeEvent = (type, info, ctx) => ({
    type,
    timestamp: getCurrentUTCDateTime(),
    info,
    ...(ctx.participant_or_caregiver_id
      ? { participant_or_caregiver_id: ctx.participant_or_caregiver_id }
      : {})
  })

export const formatEventBody = (type, infoKey, infoValue, additionalInfo = {}) => {
  const values = Array.isArray(infoValue) ? infoValue : [infoValue]
  const eventsArr = values.map(value => {
    const info = { utc_offset: getUTCOffset() }

    if (infoKey) {
      info[infoKey] = value
    }

    // Add additional info fields if provided
    Object.keys(additionalInfo).forEach(key => {
      if (additionalInfo[key] !== undefined && additionalInfo[key] !== null) {
        info[key] = additionalInfo[key]
      }
    })

    const ctx = getEventContext()
    const infoWithContext = applyContextToInfo(info, ctx)

    return makeEvent(type, infoWithContext, ctx)
  })
  return JSON.stringify(eventsArr)
}

export const formatInstanceEventBody = (type, infoValues) => {
  const info = { utc_offset: getUTCOffset(), ...infoValues }
  const ctx = getEventContext()
  const infoWithContext = applyContextToInfo(info, ctx)
  return JSON.stringify([makeEvent(type, infoWithContext, ctx)])
}

export const formatAllInstancesEventBody = (type, instancesArr = []) => {
  const allInstancesArr = []
  const ctx = getEventContext()
  instancesArr.forEach(({ instrument_type, instrument_id, instances }) => {
    (instances || []).forEach(({ instance_id }) => {
      if (!instance_id) return
      const info = {
        utc_offset: getUTCOffset(),
        [instrument_type === 'ANNOUNCEMENT'
          ? EVENT_KEY_MAP.announcementId
          : EVENT_KEY_MAP.depQId]: instrument_id,
        [EVENT_KEY_MAP.instanceId]: instance_id
      }
      const infoWithContext = applyContextToInfo(info, ctx)
      allInstancesArr.push(makeEvent(type, infoWithContext, ctx))
    })
  })
  return JSON.stringify(allInstancesArr)
}

export const formatVisibleInstancesEventBody = (type, instancesArr = []) => {
  const ctx = getEventContext()
  return JSON.stringify(
    instancesArr
      .filter((group) => group?.instances?.[0]?.instance_id)
      .map(({ instrument_type, instrument_id, instances }) => {
        const info = {
          utc_offset: getUTCOffset(),
          [instrument_type === 'ANNOUNCEMENT'
            ? EVENT_KEY_MAP.announcementId
            : EVENT_KEY_MAP.depQId]: instrument_id,
          [EVENT_KEY_MAP.instanceId]: instances[0].instance_id
        }
        const infoWithContext = applyContextToInfo(info, ctx)
        return makeEvent(type, infoWithContext, ctx)
      })
  )
}
